import DynamicWizard from 'components/crud/DynamicWizard'
import React from 'react'
import { useParams } from "react-router-dom";
import { vendorRequestWizardConfig } from './config';

const RaiseVendorRequest = () => {
    const params = useParams();
    return (
        <div>
            <DynamicWizard
                config={vendorRequestWizardConfig}
                onFinished={() => { }}
                recordId={90}
                params={params}
            />
        </div>
    )
}

export default RaiseVendorRequest;